export default {
  /**
   * Add post to posts
   * @param state
   * @param post
   */
  addGalleryPost(state, { post }) {
    state.posts.push(post);
    state.totalPostsCount += 1;
  },
  /**
   * Update post
   * @param state
   * @param post
   */
  updateGalleryPost(state, { post }) {
    let postToUpdate = state.posts.find(p => p.uuid === post.uuid);
    postToUpdate.images = post.images;
    postToUpdate.description = post.description;
  },
  /**
   * Delete post by uuid
   * @param state
   * @param uuid
   */
  deleteGalleryPost(state, uuid) {
    state.posts = [...state.posts.filter(post => post.uuid !== uuid)];
    state.totalPostsCount -= 1;
  },
  /**
   * Set posts
   * @param state
   * @param posts
   */
  setGalleryPosts(state, posts) {
    state.posts = posts.items;
    state.totalPostsCount = posts.count;
  }
};
